import { formatLocale } from 'd3-format'

export const getChangeInPercent = (value, baselineValue) =>
	(100 * (value - baselineValue)) / baselineValue

export const stringToDate = (_date, _format, _delimiter) => {
	const formatLowerCase = _format.toLowerCase()
	const formatItems = formatLowerCase.split(_delimiter)
	const dateItems = _date.split(_delimiter)
	const monthIndex = formatItems.indexOf('mm')
	const dayIndex = formatItems.indexOf('dd')
	const yearIndex = formatItems.indexOf('yyyy')
	return new Date(
		`${dateItems[yearIndex]}-${dateItems[monthIndex]}-${dateItems[dayIndex]}`
	)
}

export const zeroPad = (x) => `00${x}`.slice(-2)

export function formatDay(date) {
	const day = date.getDate()
	const monthIndex = date.getMonth()
	const year = date.getFullYear()
	return `${zeroPad(day)}.${zeroPad(monthIndex + 1)}.${year}`
}

export function formatDayShort(date) {
	const day = date.getDate()
	const monthIndex = date.getMonth()
	return `${day}.${monthIndex + 1}.`
}

export function formatDayISO(date) {
	const day = date.getDate()
	const monthIndex = date.getMonth()
	const year = date.getFullYear()
	return `${year}-${zeroPad(monthIndex + 1)}-${zeroPad(day)}`
}

export const px = (str) => `${str}px`
export const deg = (str) => `${str}deg`
export const percent = (str) => `${str}%`
export const celcius = (str) => `${str} °C`

const monthNamesShort = [
	'Jan',
	'Feb',
	'Mär',
	'Apr',
	'Mai',
	'Jun',
	'Jul',
	'Aug',
	'Sep',
	'Okt',
	'Nov',
	'Dez'
]

export function formatMonth(date) {
	const monthIndex = date.getMonth()
	const year = date.getFullYear()
	return `${zeroPad(monthIndex + 1)}.${year}`
}

export function formatOnlyMonth(date) {
	const monthIndex = date.getMonth()
	return monthNamesShort[monthIndex]
}

export function formatYear(date) {
	const year = date.getFullYear()
	return `${year}`
}

/* AUTOMATIC X-TICKS */

/* | Jan | Feb | Mär | ... */

export function getXTicksMonths(start, end, addIncompleteMonth) {
	let s = new Date(+start)
	let e = new Date(+end)
	let r = []

	if (addIncompleteMonth && e.getDate() >= 20) e.setDate(e.getDate() + 12)
	if (addIncompleteMonth && s.getDate() <= 10) s.setDate(s.getDate() - 12)
	while (+s <= +e) {
		if (s.getDate() === 1) r.push(new Date(+s))
		s.setDate(s.getDate() + 1)
	}

	return r
}

export function getXTicksYears(start, end) {
	let s = new Date(+start)
	let e = new Date(+end)
	let r = []

	while (+s <= +e) {
		r.push(new Date(+s))
		s.setFullYear(s.getFullYear() + 1)
	}
	return r
}

export function getXTicksLabelsPositionsMonths(start, end) {
	const ticks = getXTicksMonths(start, end, true)
	let r = []
	for (let i = 0; i < ticks.length - 1; i++) {
		r.push(new Date(+ticks[i] + (+ticks[i + 1] - +ticks[i]) / 2))
	}
	return r
}

export function getXTicksLabelsMonths(start, end) {
	const ticks = getXTicksMonths(start, end, true)
	let r = []
	for (let i = 0; i < ticks.length - 1; i++) {
		r.push(monthNamesShort[ticks[i].getMonth()])
	}
	return r
}

/* |1.1.  |1.2.  |1.3  |1.4 */

export function getXTicksMonthsFirst(start, end) {
	return getXTicksMonths(start, end)
}

export function getXTicksLabelsPositionsMonthsFirst(start, end) {
	return getXTicksMonths(start, end)
}

export function getXTicksLabelsMonthsFirst(start, end) {
	return getXTicksMonths(start, end).map(formatDayShort)
}

/* |1.1. ||||...  |1.2. ||||.... |1.3 ||||...  |1.4 |.... */

export function getXTicksDays(start, end) {
	let s = new Date(+start)
	let e = new Date(+end)
	let r = []
	while (+s <= +e) {
		r.push(new Date(+s))
		s.setDate(s.getDate() + 1)
	}
	return r
}

export function getXTicksMonthsDays(start, end) {
	return getXTicksDays(start, end)
}

export function getXTicksLabelsPositionsMonthsDays(start, end) {
	return getXTicksMonths(start, end)
}

export function getXTicksLabelsMonthsDays(start, end) {
	return getXTicksMonths(start, end).map(formatDayShort)
}

/* |<start> |||.... |<end> */

export function getXTicksRange(start, end) {
	return getXTicksDays(start, end)
}

export function getXTicksLabelsPositionsRange(start, end) {
	return [start, end]
}

export function getXTicksLabelsRange(start, end) {
	return [start, end].map(formatDayShort)
}

/* start plus end date plus start of months in between */
export function getXTicksStartEndMonths(start, end) {
	let s = new Date(+start)
	let st = new Date(+start)
	let e = new Date(+end)
	let en = new Date(+end)
	let r = [st]

	e.setDate(e.getDate() - 27)
	if (s.getDate() > 5) s.setDate(s.getDate() + 27)
	while (+s < +e) {
		if (s.getDate() === 1) r.push(new Date(+s))
		s.setDate(s.getDate() + 1)
	}
	r.push(en)

	return r
}

/* tick in the middle of a year */
export function getXTicksLabelsPositionsYearsMiddle(start, end) {
	const ticks = getXTicksYears(start, end)
	let r = []
	for (let i = 0; i < ticks.length - 1; i++) {
		r.push(new Date(+ticks[i] + (+ticks[i + 1] - +ticks[i]) / 2))
	}
	return r
}
export function getXTicksLabelsYearsMiddle(start, end) {
	const ticks = getXTicksYears(start, end)
	let r = []
	for (let i = 0; i < ticks.length - 1; i++) {
		r.push(formatYear(ticks[i]))
	}
	return r
}

const weekdays = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa']

export function getWeekday(date) {
	const wday = date.getDay()
	return weekdays[wday]
}

/* NUMBER FORMATTING */

const format = { decimal: ',', thousands: '.', currencyPre: false }
const locale = formatLocale({
	decimal: format.decimal,
	thousands: format.thousands,
	grouping: [3]
})

function fixThousandSep(x, sep) {
	const s = x.split(sep)
	if (s.length !== 2) return x
	if (s[0].length !== 1) return x
	return x.replace(sep, '')
}

const formatIntDefaultOptions = {
	postfix: '',
	prefix: ''
}

export function formatInt(opts) {
	const o = { ...formatIntDefaultOptions, ...opts }
	return (x) =>
		(o.prefix || '') +
		fixThousandSep(locale.format(',d')(x), format.thousands) +
		(o.postfix || '')
}

const formatFloatDefaultOptions = {
	digits: 1,
	postfix: '',
	prefix: '',
	multiplier: 1,
	signed: false,
	decimal: false, // remove trailing zeros
	adaptive: true // add extra digits for small numbers
}

export function formatFloat(opts) {
	const o = { ...formatFloatDefaultOptions, ...opts }

	return function (x) {
		let ds = o.digits
		if (x === '' || x === null || x === undefined) return ''
		if (o.adaptive) {
			// D 2021-04-22 removed the following line, to have 12,8 and 0,3 (instead of 0,31)
			// if (Math.abs(x * o.multiplier) < 1) ds += 1;
			if (Math.abs(x * o.multiplier) < 0.1) ds += 1
			if (Math.abs(x * o.multiplier) < 0.01) ds += 1
			if (Math.abs(x * o.multiplier) < 0.001) ds += 1
		}
		let s = locale.format(`${o.signed ? '+' : ''},.${ds}f`)(x * o.multiplier)
		if (x === 0) s = s.replace('+', '')
		s = fixThousandSep(s, format.thousands)
		if (o.adaptive && s.replace(/0/g, '').replace(format.decimal, '') === '')
			s = '0'
		if (o.decimal) {
			s = s.replace(new RegExp(`${format.decimal.replace('.', '\\.')}0*$`), '')
			if (s.indexOf(format.decimal) > -1) {
				s = s.replace(/0*$/, '')
			}
		}
		return (o.prefix || '') + s + (o.postfix || '')
	}
}

export function scrollTo(elem, offset = 0, returnPromise) {
	const tBody = document.documentElement.getBoundingClientRect().top
	const tE = elem.getBoundingClientRect().top
	const t = tE - tBody + offset
	window.scrollTo({ top: t, behavior: 'smooth' })
	return returnPromise
		? new Promise((resolve, reject) => {
				const failed = setTimeout(() => {
					reject()
				}, 2000)

				const scrollHandler = () => {
					if (window.pageYOffset === t) {
						window.removeEventListener('scroll', scrollHandler)
						clearTimeout(failed)
						resolve()
					}
				}
				if (window.pageYOffset === t) {
					clearTimeout(failed)
					resolve()
				} else {
					window.addEventListener('scroll', scrollHandler)
				}
			})
		: true
}
